import { Action } from 'redux';
// Import States.
import {
	AppState,
} from '@app/redux/states';
// Import Actions.
import {
	LoadDisqualifiersTextAction,
} from '@app/redux/actions';
// Import api models.
import {
	DisqualifiersText,
} from '@app/models/api';


/**
 * This handles initializing the state.
 * @param state
 * @param action
 */
let initializeState = (state: AppState): AppState => {
	let newState: AppState = { ...state };
	return newState;
}

// Load Disqualifiers Text Reducer.

let LoadDisqualifiersTextReducer = (state: AppState, action: Action): AppState => {
	let loadDisqualifiersTextAction: LoadDisqualifiersTextAction = action as LoadDisqualifiersTextAction;
	let disqualifiersText: DisqualifiersText = loadDisqualifiersTextAction.disqualifiersText;

	// Create copy of the of app state.
	let newState: AppState = initializeState(state);

	newState.disqualifiersText = disqualifiersText;

	return newState;
}


// Export reducers.
export {
	LoadDisqualifiersTextReducer,
};